// Utilidades para exportar investigaciones a archivo descargable

import { CATEGORY_META } from './data';

function fmtDate(iso) {
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString('es-AR', { day: '2-digit', month: 'long', year: 'numeric' });
}

function slugify(s) {
  return String(s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}

export function buildMarkdown(item) {
  const cat = CATEGORY_META[item.category]?.label || item.category;
  const tags = (item.tags || []).map((t) => `#${t}`).join(' ');
  return `# ${item.title}

> ${item.type} · ${cat} · ${fmtDate(item.date)}
> Autor: **${item.author}**
${tags ? `\n${tags}\n` : ''}
---

${item.excerpt}

${item.body || ''}

---

_Exportado desde Arcana Vision · ${new Date().toLocaleDateString('es-AR')}_
`;
}

export function buildJSON(item) {
  return JSON.stringify(
    {
      ...item,
      exported_at: new Date().toISOString(),
      source: 'Arcana Vision',
    },
    null,
    2
  );
}

export function downloadBlob(content, filename, mime) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export function downloadMarkdown(item) {
  const md = buildMarkdown(item);
  downloadBlob(md, `${slugify(item.title)}.md`, 'text/markdown;charset=utf-8');
}

export function downloadJSON(item) {
  const json = buildJSON(item);
  downloadBlob(json, `${slugify(item.title)}.json`, 'application/json');
}

export function printItem(item) {
  // abre una ventana imprimible que el usuario puede guardar como PDF
  const win = window.open('', '_blank', 'width=820,height=1100');
  if (!win) return;
  const cat = CATEGORY_META[item.category]?.label || item.category;
  const tags = (item.tags || []).map((t) => `<span class="tag">#${t}</span>`).join('');
  // markdown crudo en bloques pre, mejor que nada
  const body = (item.body || '').replace(/</g, '&lt;');
  win.document.write(`
<!doctype html>
<html lang="es">
<head>
<meta charset="utf-8" />
<title>${item.title}</title>
<style>
  body { font-family: -apple-system, Segoe UI, Roboto, Arial, sans-serif; color: #1B263B; padding: 48px; max-width: 760px; margin: 0 auto; }
  h1 { font-size: 28px; margin: 0 0 6px; }
  .meta { color: #6c7a89; font-size: 13px; margin-bottom: 18px; }
  .badge { display: inline-block; background: #00B4D8; color: white; padding: 2px 8px; border-radius: 3px; font-size: 11px; letter-spacing: 0.1em; text-transform: uppercase; margin-right: 6px; }
  .tag { display: inline-block; background: #f0fafd; border: 1px solid #b9e6f3; color: #0089a6; padding: 1px 7px; border-radius: 3px; font-size: 11px; margin-right: 4px; }
  hr { border: none; border-top: 1px solid #ddd; margin: 24px 0; }
  pre { white-space: pre-wrap; font-family: inherit; line-height: 1.55; font-size: 14px; }
  footer { color: #94a0ad; font-size: 11px; margin-top: 30px; border-top: 1px dashed #ccc; padding-top: 10px; }
</style>
</head>
<body>
<h1>${item.title}</h1>
<div class="meta">
  <span class="badge">${item.type}</span>
  <span class="badge" style="background:#06D6A0">${cat}</span>
  ${fmtDate(item.date)} · <strong>${item.author}</strong>
</div>
<div>${tags}</div>
<hr />
<p>${item.excerpt}</p>
<pre>${body}</pre>
<footer>Arcana Vision · exportado el ${new Date().toLocaleString('es-AR')}</footer>
<script>window.onload = () => { setTimeout(() => window.print(), 250); }</script>
</body>
</html>`);
  win.document.close();
}
